export default (n) => Number(Math.round(n + 'e2') + 'e-2');
